import { useMemo } from "react";

import {
  Box,
  Text,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Heading,
  Stack,
  VStack,
  CircularProgress,
  // useDisclosure,
  List,
} from "@chakra-ui/react";

import { useParams } from "react-router-dom";

// import Arrow from "assets/svg/icons-new/arrow.svg";

import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Button from "components/Button/Button";
// import Select from "components/Select/Select";
// import Input from "components/Input/Input";
// import SuccessModal from "components/Modals/Success";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

// import HistoryItem from "components/AffiliateItems/HistoryItem";
import DetailItem from "components/DetailItem/DetailItem";

// import constant from "config/constant";
// import toPrecision from "util/toPrecision";
import toCoinLocale from "util/toCoinLocale";

import { useGetAffiliateEarningDetailsQuery } from "services/walletApi";

import { format, parseISO } from "date-fns";

export default function RewardHistoryEarningDetails(props) {
  //   const { userData } = props;

  const { id } = useParams();

  //   const toast = useToast();
  //   const loaded = useRef(false);
  //   const history = useHistory();
  // const { isOpen, onOpen, onClose } = useDisclosure();
  //   const [state, _setState] = useState({ type: "price" });

  //   const setState = (newState) => _setState(() => ({ ...state, ...newState }));

  const { data, isLoading } = useGetAffiliateEarningDetailsQuery(id);

  const details = useMemo(() => data?.earning, [data]);

  console.log("DETAILS", data);

  return (
    <Box>
      <Sidemenu currentPage="Account" logoutUser={props.logout} />
      <Header />
      <Box as="section">
        <Box
          className="account-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 15vw)", "calc(100% - 30vw)"]}
            m="0"
            p={[0, 0, "1rem"]}
          >
            <Stack mx={["24px", 0]} mb={["24px", "32px"]}>
              <Heading>Earning details</Heading>
              <Breadcrumb
                className="animate__animated animate__fadeInDown"
                separator={
                  <ArrowForwardIosRoundedIcon
                    style={{ fontSize: ".8em", color: "#6E7191" }}
                  />
                }
              >
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account">
                    Account
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account/partners">
                    Reward History
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account/partners/earnings">
                    Reward History Earnings
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to="">
                    Details
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Stack>

            <Box
              bg="white"
              p={["32px 24px", "32px 24px", "40px 22px"]}
              //   mt={["24px", "10px"]}
              borderRadius={[0, "8px", "16px"]}
            >
              <VStack>
                {isLoading && (
                  <CircularProgress
                    disabled
                    isIndeterminate
                    color="#a7a7a7"
                    size="32px"
                  />
                )}

                {!isLoading && !details && <Text>Not found</Text>}
              </VStack>

              {details && (
                <List>
                  <DetailItem
                    itemTitle="Name"
                    value={details?.referredUserId?.fullName}
                  />
                  <DetailItem
                    itemTitle="Email"
                    value={details?.referredUserId?.email}
                  />
                  {/* <DetailItem itemTitle="Transaction" value="Bought 10 Celo" /> */}
                  <DetailItem
                    itemTitle="Rewards earned"
                    value={`${
                      details?.signedValue.$numberDecimal
                    } ${toCoinLocale(details?.unit)}`}
                  />
                  {/* <DetailItem itemTitle="Verification status" value="Level 2" /> */}
                  <DetailItem
                    itemTitle="Date"
                    value={format(parseISO(details?.createdAt), "MMMM e, yyyy")}
                  />
                </List>
              )}
            </Box>
          </Container>
        </Box>
      </Box>

      {/* <SuccessModal
        isOpen={isOpen}
        onClose={handleClose}
        title="Success"
        message={`Price alert successfully updated `}
      /> */}
    </Box>
  );
}
